import React, { FC } from 'react';
import { NavigationProps } from '@interfaces/navigation';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import BatchListContent from '@v2/pages/common/components/BatchListContent/BatchListContent';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL_FOR_PAGE, SCREEN_PADDING_VERTICAL_FOR_ITEM } from '@v2/pages/common/constants/base.constants';
import { isPhone, isWeb } from '@helpers';
import { MODE } from '@v2/pages/machines/common/enums';
import { useChangeDisplayModeOnResize } from '@v2/pages/common/hooks/useChangeDisplayModeOnResize';
import { useTrackMachineHistoryOpened } from './hooks/useTrackMachineHistoryOpened';

interface BatchesProps extends NavigationProps {}

const Batches: FC<BatchesProps> = ({ lg }) => {
  useTrackMachineHistoryOpened();

  const { mode } = useChangeDisplayModeOnResize();

  return (
    <MachinesProvider
      mode={isWeb ? mode : isPhone ? MODE.DETAILS : MODE.FULL}
      lg={lg}
      panelViewMode={false}
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <View
        style={{
          paddingHorizontal: scale(
            isWeb ? (mode === MODE.DETAILS ? 0 : SCREEN_PADDING_HORIZONTAL_FOR_PAGE) : isPhone ? 0 : SCREEN_PADDING_HORIZONTAL_FOR_PAGE
          ),
          paddingTop: scale(SCREEN_PADDING_VERTICAL_FOR_ITEM),
          flex: 1,
        }}
      >
        <BatchListContent noMachine={false} noSearchScreen backgroundColorForTile="Background/Light/Field" />
      </View>
    </MachinesProvider>
  );
};

export { Batches };
